import type { MessageHandlerDeps } from '../../message-handler-deps.js';

type SessionGitReply = (payload: Record<string, unknown>, encryptedFields?: readonly string[]) => void;

export async function handleSessionGitStatusAction(
  deps: MessageHandlerDeps,
  sessionId: string,
  reply: SessionGitReply,
): Promise<void> {
  const r = await deps.sessionWorktreeManager.getSessionWorkingTreeStatus(sessionId);
  reply({
    ok: true,
    hasUncommittedChanges: r.hasUncommittedChanges,
    hasUnpushedCommits: r.hasUnpushedCommits,
    uncommittedFileCount: r.uncommittedFileCount,
  });
}
